function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Pagination from '../pagination';
var prefixCls = 'eui-table';

var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table() {
    var _this;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      current: 1
    });

    _defineProperty(_assertThisInitialized(_this), "onCurrentChange", function (current) {
      _this.setState({
        current: current
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTable", function (columns, dataSource) {
      var _this$props = _this.props,
          rowClassName = _this$props.rowClassName,
          onRow = _this$props.onRow,
          className = _this$props.className;
      var classes = classNames(prefixCls, className);
      return /*#__PURE__*/React.createElement("table", {
        className: classes
      }, /*#__PURE__*/React.createElement("thead", {
        className: "".concat(prefixCls, "-thead")
      }, /*#__PURE__*/React.createElement("tr", {
        className: "".concat(prefixCls, "-tr")
      }, columns.map(function (item) {
        return /*#__PURE__*/React.createElement("th", {
          className: "".concat(prefixCls, "-th"),
          key: item.dataIndex
        }, item.title);
      }))), /*#__PURE__*/React.createElement("tbody", {
        className: "".concat(prefixCls, "-tbody")
      }, dataSource.map(function (item, index) {
        return /*#__PURE__*/React.createElement("tr", {
          key: item.key,
          className: "".concat(prefixCls, "-tr ").concat(rowClassName ? rowClassName(item, index) : ''),
          onClick: function onClick(e) {
            onRow && onRow.onClick && onRow.onClick(item, index, e);
          },
          onMouseEnter: function onMouseEnter(e) {
            onRow && onRow.onClick && onRow.onMouseEnter(item, index, e);
          },
          onMouseLeave: function onMouseLeave(e) {
            onRow && onRow.onClick && onRow.onMouseLeave(item, index, e);
          }
        }, columns.map(function (item1) {
          return /*#__PURE__*/React.createElement("td", {
            className: "".concat(prefixCls, "-td"),
            key: item1.dataIndex
          }, item1.render ? item1.render(item[item1.dataIndex]) : item[item1.dataIndex]);
        }));
      })));
    });

    return _this;
  }

  _createClass(Table, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var current = this.state.current;
      var dataSource = this.props.dataSource;
      var nextDataSource = nextProps.dataSource,
          nextPagination = nextProps.pagination;

      if (nextPagination && nextDataSource !== dataSource) {
        var pageSize = nextPagination.pageSize;

        if (pageSize * (current - 1) >= nextDataSource.length) {
          var nextCurrent = Math.ceil(nextDataSource.length / pageSize);
          if (nextCurrent === 0) nextCurrent = 1;
          this.setState({
            current: nextCurrent
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          dataSource = _this$props2.dataSource,
          columns = _this$props2.columns,
          pagination = _this$props2.pagination,
          children = _this$props2.children;
      var current = this.state.current;
      var pageSize = pagination ? pagination.pageSize : dataSource.length;
      var tempDataSource = dataSource.slice((current - 1) * pageSize, current * pageSize);
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-wrapper")
      }, this.renderTable(columns, tempDataSource), children, pagination ? /*#__PURE__*/React.createElement(Pagination, {
        className: "".concat(prefixCls, "-pagination"),
        currentPage: current,
        pageSize: pageSize,
        total: dataSource.length,
        onCurrentChange: this.onCurrentChange
      }) : null);
    }
  }]);

  return Table;
}(React.Component);

_defineProperty(Table, "defaultProps", {
  pagination: null,
  onRow: {},
  rowClassName: undefined
});

_defineProperty(Table, "propTypes", {
  dataSource: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  pagination: PropTypes.object,
  onRow: PropTypes.object,
  rowClassName: PropTypes.func
});

export default Table;